import {
  CHECK_LABELS,
  checkMeaningText,
  checkValueText,
  formatInstant,
  sourceLabel,
} from '../lib/format.js';
import type { Check, CheckName } from '../lib/types.js';
import { cx } from './classes.js';
import { STATUS_TEXT, StatusGlyph } from './StatusGlyph.js';

/**
 * The atom of a verification (design v1): what was checked, the answer,
 * where it came from, when. Glyph + word, never a pill. A check that
 * carries a `meaning` (the ZRA status vocabulary, the owner-TPIN prompt)
 * gets it as a second, muted line under the reading.
 */
export function CheckRow({
  name,
  check,
  first = false,
  showReadAt = false,
}: {
  name: CheckName;
  check: Check;
  first?: boolean;
  showReadAt?: boolean;
}) {
  const source = sourceLabel(check.source);
  const meaning = checkMeaningText(check);
  return (
    <div
      className={cx(
        'grid grid-cols-[22px_minmax(0,1fr)_220px_90px] items-center gap-3.5 py-3 text-[14px]',
        !first && 'border-t border-line',
      )}
      data-testid="check-row"
      data-check={name}
    >
      <StatusGlyph status={check.status} />
      <span>{CHECK_LABELS[name]}</span>
      <span className="flex min-w-0 flex-col gap-0.5">
        <span className={cx('font-medium', STATUS_TEXT[check.status])}>
          {checkValueText(name, check)}
        </span>
        {meaning ? (
          <span className="text-[12px] leading-snug text-mute">{meaning}</span>
        ) : null}
      </span>
      <span
        className="text-right text-mute"
        title={check.read_at ? `read ${formatInstant(check.read_at)}` : undefined}
      >
        {showReadAt && check.read_at
          ? `${source} · ${formatInstant(check.read_at)}`
          : source}
      </span>
    </div>
  );
}
